import { Rule } from 'antd/lib/form';
import { Dictionary } from 'lodash';
import { Subscription } from 'api/billing/types';
import { Option } from 'components/atoms/select';
import { Member } from 'data/members/api';

export enum TeamMembersTabsEnum {
  Active = 'active',
  Invited = 'invited',
  Deactivated = 'deactivated',
}

export interface TeamMemberDrawerStateProps {
  visible: boolean;
  readOnly: boolean;
  selected?: Member | undefined;
}
export interface TeamMemberDrawerSectionProps {
  hideFieldsSection?: boolean;
  hideCapacitySection?: boolean;
  hideRoleCreation?: boolean;
  hideTimesheetApproverSection?: boolean;
}

export type TeamMembersDrawerProps = {
  drawerState: TeamMemberDrawerStateProps;
  onClose(): void;
  showMemberDetail(member: Member): void;
  changeToEditMode(member: Member): void;
  onUserInvited(): void;
  onInviteSubmit?(formValues): void;
  showLoader?: boolean;
  drawerSectionProps: TeamMemberDrawerSectionProps;
  permissionOptions: Option[];
  roleOptions: Option[];
  formInputRules?: Dictionary<Rule[]>;
  processRequestInParent?: boolean;
  isVendorInvite: boolean;
};

export type InviteComponentProps = TeamMembersDrawerProps & {
  subscription: Subscription;
  availableLicenses: number;
};
